<span class="login" [style.background-image]="getBackgroundImage()">
  <app-commerror></app-commerror>

  <div class="login-wrapper l-table">
    <div class="l-row">
      <header class="l-flex-c login-header">
        <div class="login-logo logo-3d-effect">
          <img src="assets/icons/logo.svg" alt="Artisan sonics logo" />
        </div>
        <h1 class="login-title">We Communicate Healthcare <strong>To Your Patient</strong></h1>
      </header>
    </div>

    <div class="l-row">
      <div class="l-td-m h100 login-main">
        <h2 class="login-title-2">
          Your patient is at the center of your work,
          <br />
          <strong> With Artisan sharing healthcare information Made Easy </strong>
        </h2>

        <div class="login-form glass-card">
          <ng-container
            *ngIf="
              !loginService.clinicOptions &&
              !showTwoFactorInput &&
              !showUpdateInfoForm &&
              !showPrivacyPolicy
            "
          >
            <!-- <div *ngIf="loginService.loginError" class="strong login-error">{{loginService.loginError}}</div> -->
            <div *ngIf="loginService.loginError" class="login-error main-err">
              <mat-icon class="error-icon">cancel</mat-icon>
              <span class="error-text">{{ loginService.loginError }}</span>
              <button
                class="error-close-btn"
                (click)="clearError()"
                aria-label="Close error message"
              >
                &times;
              </button>
            </div>

            <button
              *ngIf="loginService.twoFaAlternateMethod"
              type="button"
              class="twofa-alt-btn"
              (click)="tryAlternate2FA()"
              [disabled]="loginService.isLoginLoading"
            >
              Try {{ loginService.twoFaAlternateMethod === 'sms' ? 'SMS' : 'WhatsApp' }} instead
            </button>

            <div class="login-form-row" *ngIf="!loginService.getCode">
              <input
                class="login-form-field focusOnParent"
                type="text"
                placeholder="User Name"
                aria-label="user name"
                [(ngModel)]="user"
                (keyup)="clean()"
                (keyup.enter)="checkLogin()"
              />
              <i class="login-form-icon icon-userName"></i>
            </div>

            <div class="login-form-row" *ngIf="!loginService.getCode">
              <input
                class="login-form-field focusOnParent"
                [type]="hidepw ? 'password' : 'text'"
                placeholder="Password"
                aria-label="password"
                (keyup.enter)="checkLogin()"
                (keyup)="clean()"
                (focus)="typed = true"
                [(ngModel)]="pw"
                pattern="^[a-zA-Z0-9]+$"
              />
              <i
                class="login-form-icon {{
                  !typed ? 'icon-password' : hidepw ? 'icon-openpw' : 'icon-closepw'
                }}"
                (click)="hidepw = !hidepw"
              ></i>
            </div>

            <div *ngIf="loginService.getCode" class="login-form-row">
              <input
                class="login-form-field focusOnParent"
                type="text"
                placeholder="Code from sms"
                [(ngModel)]="code"
                (keyup.enter)="checkLogin()"
                aria-label="user name"
              />
              <i class="login-form-icon icon-code"></i>
            </div>

            <button
              type="submit"
              class="login-form-submit t-btn-grad"
              (click)="getotp()"
              [disabled]="loginService.isLoginLoading"
            >
              <span [class.hidden]="loginService.isLoginLoading">Login</span>
              <mat-spinner
                *ngIf="loginService.isLoginLoading"
                class="button-spinner"
                [diameter]="24"
              ></mat-spinner>
            </button>

            <div class="login-extra-links">
              <a class="forgot-password-link" (click)="openForgotPasswordDialog()"
                >Forgot Password?</a
              >
            </div>
          </ng-container>

          <ng-container
            *ngIf="
              showTwoFactorInput &&
              !loginService.clinicOptions &&
              !showUpdateInfoForm &&
              !showPrivacyPolicy
            "
          >
            <div *ngIf="loginService.loginError" class="login-error">
              <mat-icon class="error-icon">cancel</mat-icon>
              <span class="error-text">{{ loginService.loginError }}</span>
              <button
                class="error-close-btn"
                (click)="clearError()"
                aria-label="Close error message"
              >
                &times;
              </button>
            </div>

            <div class="two-factor-wrapper">
              <h2 class="login-title-3"><strong>Two-Factor Authentication</strong></h2>
              <p class="two-factor-subtitle">
                A verification code has been sent to your registered mobile device. Please enter it
                below.
              </p>

              <div class="otp-input-container">
                <input
                  #otpInput
                  type="text"
                  class="otp-input"
                  maxlength="6"
                  pattern="[0-9]*"
                  inputmode="numeric"
                  [(ngModel)]="twoFactorCode"
                  (ngModelChange)="onCodeInputChange()"
                  (paste)="onCodePaste($event)"
                  (focus)="onOtpFocus()"
                  (blur)="onOtpBlur()"
                  autocomplete="one-time-code"
                />

                <div class="otp-boxes">
                  <div class="otp-box" [class.filled]="twoFactorCode.length > 0">
                    {{ twoFactorCode[0] || '' }}
                    <span class="otp-cursor" *ngIf="isCursorVisible(0)"></span>
                  </div>
                  <div class="otp-box" [class.filled]="twoFactorCode.length > 1">
                    {{ twoFactorCode[1] || '' }}
                    <span class="otp-cursor" *ngIf="isCursorVisible(1)"></span>
                  </div>
                  <div class="otp-box" [class.filled]="twoFactorCode.length > 2">
                    {{ twoFactorCode[2] || '' }}
                    <span class="otp-cursor" *ngIf="isCursorVisible(2)"></span>
                  </div>
                  <div class="otp-box" [class.filled]="twoFactorCode.length > 3">
                    {{ twoFactorCode[3] || '' }}
                    <span class="otp-cursor" *ngIf="isCursorVisible(3)"></span>
                  </div>
                  <div class="otp-box" [class.filled]="twoFactorCode.length > 4">
                    {{ twoFactorCode[4] || '' }}
                    <span class="otp-cursor" *ngIf="isCursorVisible(4)"></span>
                  </div>
                  <div class="otp-box" [class.filled]="twoFactorCode.length > 5">
                    {{ twoFactorCode[5] || '' }}
                    <span class="otp-cursor" *ngIf="isCursorVisible(5)"></span>
                  </div>
                </div>
              </div>

              <!-- <div *ngIf="loginService.loginError" class="strong login-error">{{loginService.loginError}}</div> -->

              <button
                class="login-form-submit t-btn-grad"
                (click)="verifyTwoFactorCode()"
                [disabled]="is2faLoading"
              >
                <span *ngIf="!is2faLoading">Verify & Login</span>
                <mat-spinner
                  *ngIf="is2faLoading"
                  class="button-spinner"
                  [diameter]="24"
                ></mat-spinner>
              </button>

              <div class="resend-container" *ngIf="resendAttemptCount < 1 || !canResend">
                <span *ngIf="!canResend">Didn't receive the code? Resend in {{ countdown }}s</span>

                <a
                  *ngIf="canResend && resendAttemptCount < 1"
                  (click)="resendCode()"
                  class="resend-link"
                >
                  <ng-container *ngIf="resendAttemptCount === 0">Resend Code</ng-container>
                </a>
              </div>

              <div class="smsSend-container" *ngIf="resendAttemptCount >= 1 && canResend">
                <span
                  >Having issues getting your Code?
                  <br />
                  Send By<a
                    class="resend-link"
                    [class.disabled]="!canResend"
                    (click)="sendSelectedCode('whatsapp')"
                  >
                    Whatsapp</a
                  >
                  Or By<a
                    class="resend-link"
                    [class.disabled]="!canResend"
                    (click)="sendSelectedCode('sms')"
                  >
                    SMS</a
                  >
                </span>
              </div>

              <a class="back-to-login-link" (click)="goBackToLogin()">&#8592; Back to Login</a>
            </div>
          </ng-container>

          <ng-container *ngIf="showPrivacyPolicy">
            <div class="privacy-policy-wrapper">
              <h2 class="login-title-3"><strong>Privacy Policy</strong></h2>
              <p class="two-factor-subtitle">
                Please review our updated privacy policy. You must scroll to the bottom to continue.
              </p>

              <div class="privacy-policy-content" (scroll)="onPolicyScroll($event)">
                <div class="innerHTML">
                  <p>
                    <strong>ארטיסן סוניקס בע"מ, ח"פ 512212622 (להלן: "החברה")</strong> מכבדת את
                    הפרטיות של המשתמשים בשירותיה של החברה, לרבות באמצעות אתרי האינטרנט שבבעלות החברה
                    אותם היא מנהלת ומפעילה בכתובות https://artisansonics.com ו
                    https://artisanmedical.co.il (להלן: "המשתמש" או "המשתמשים" ו-"האתר", בהתאמה).
                  </p>
                  <p>
                    מדיניות פרטיות זו ומדיניות ה-Cookies (להלן יחד: "מדיניות הפרטיות") מסדירה את
                    האופן שבו החברה עושה שימוש במידע אותו היא אוספת באתר.
                  </p>
                  <p>
                    המידע המובא להלן מיועד לסייע למשתמש להבין את מדיניות הפרטיות של החברה. מדיניות
                    הפרטיות כפי שתפורט להלן, תבהיר את המידע שהחברה אוספת אודות המשתמשים, לרבות באתר,
                    המטרות שלשמן החברה אוספת את המידע, איזה שימוש אפשר שהחברה תעשה במידע, מי הם
                    הצדדים השלישיים שהחברה תעביר להם מידע וכיצד החברה מטפלת ושומרת את המידע.
                  </p>
                  <p>
                    המידע שהמשתמש מוסר לחברה תלוי בהסכמתו וברצונו של המשתמש ואינה נובעת מחובה חוקית.
                    המידע ישמר במאגר המידע של החברה לצורך המטרות המפורטות במדיניות פרטיות זו. השימוש
                    בשירותים המוצעים על ידי החברה, לרבות באתר, מעידים על הסכמת המשתמש למדיניות
                    פרטיות זו וכי מידע יישמר וינוהל במאגר כאמור. השימוש במידע שבמאגר יעשה בהתאם
                    להוראות מדיניות פרטיות זו או על פי הוראות כל דין, למטרות המפורטות להלן.
                  </p>
                  <p>
                    מדיניות פרטיות זו כתובה בלשון זכר רק מטעמי נוחות ויש לראות בכתוב כמתייחס גם
                    ללשון נקבה.
                  </p>

                  <ol class="main-policy-list">
                    <li>
                      <strong>מהו מידע</strong>
                      <p>
                        במדיניות זו, משמעות המונח "מידע" הוא כל מידע הנאסף על ידי החברה או נמסר לה
                        על ידי המשתמש או מי מטעמו, במסגרת השימוש של המשתמש באתר או בשירותים הכלולים
                        בו, שבאמצעותו ניתן לזהות את המשתמש ומידע המוגן על פי חוק הגנת הפרטיות,
                        התשמ"א-1981 (להלן: "החוק").
                      </p>
                    </li>
                    <li>
                      <strong>המקורות שבאמצעותם החברה אוספת מידע אודות המשתמש</strong>
                      <ol class="sub-policy-list">
                        <li>
                          מידע שהמשתמש מוסר לחברה בין היתר בקשר עם התעניינות בקשר עם רכישת שירותיה
                          של החברה, לרבות באמצעות ווטסאפ, פייסבוק, LinkedIn, טלגרם, רשתות חברתיות
                          וכיוב';
                        </li>
                        <li>מידע שהמשתמש מוסר לחברה בין היתר בקשר עם רכישת שירותיה של החברה;</li>
                        <li>מידע שמתקבל אצל החברה בקשר עם השירותים שמעניקה החברה;</li>
                        <li>כאשר המשתמש מבקש להצטרף לרשימת התפוצה של החברה (ניוזלטר);</li>
                        <li>באמצעות שימוש באתר.</li>
                      </ol>
                    </li>
                    <li>
                      <strong>המידע אותו החברה אוספת אודות המשתמש</strong>
                      <p>החברה תאסוף אודות המשתמשים את המידע שיפורט להלן (כולו או חלקו):</p>
                      <ol class="sub-policy-list">
                        <li>שם מלא;</li>
                        <li>טלפון;</li>
                        <li>טלפון נייד;</li>
                        <li>דוא"ל;</li>
                        <li>תאריך לידה;</li>
                        <li>מספר ת"ז;</li>
                        <li>כתובת;</li>
                        <li>הקלטות של שיחות עם המשתמש, ככל שרלוונטי;</li>
                        <li>העדפות צרכניות של המשתמש;</li>
                        <li>
                          כל מידע נוסף שהמשתמש מוסר ו/או מתקבל אצל החברה בקשר עם המשתמש ועם השימוש
                          בשירותי החברה, לרבות שימוש באתר;
                        </li>
                        <li>
                          בנוסף, במהלך השימוש באתר, החברה תאסוף מידע לא מזהה אודות המשתמשים, אשר
                          אינו חושף את זהותם האישית של המשתמשים, כמפורט במדיניות הקוקיז בסעיף 10
                          להלן (להלן: "מידע לא מזהה").
                        </li>
                      </ol>
                    </li>
                    <li>
                      <strong
                        >מדוע החברה אוספת את המידע והשימוש שהחברה מבצעת במידע ("המטרות")?</strong
                      >
                      <p>החברה אוספת מידע אודות המשתמש לצורך המטרות הבאות - כולן או חלקן:</p>
                      <ol class="sub-policy-list">
                        <li>לשם ובקשר עם מתן השירותים המסופקים על ידי החברה או מי מטעמה;</li>
                        <li>
                          הפעלה וניהול של שירותי החברה, לרבות ניהול האתר לרבות שיווק, פרסום, קידום
                          מכירות ועידוד רכישות;
                        </li>
                        <li>על מנת לאפשר את ביצוע הפעולות באמצעות האתר על ידי המשתמש;</li>
                        <li>לשם פיתוח ותפעולו של האתר;</li>
                        <li>לשם תחזוקה של האתר וניטור פעילות המשתמש בו;</li>
                        <li>לשם שיפור איכות השירותים שמספקת החברה;</li>
                        <li>לשם יצירת קשר עם המשתמש;</li>
                        <li>
                          לשם עריכת נתונים סטטיסטיים והעברת מידע לרבות סטטיסטי או אחר, לצדדים
                          שלישיים;
                        </li>
                        <li>לשם ניתוח, ומחקר ועריכת סטטיסטיקות;</li>
                        <li>לשם עריכת סקרים בקרב המשתמשים;</li>
                        <li>
                          לשם הצגה והתאמת מודעות שיוצגו בפני המשתמשים לרבות אך לא רק ברשת האינטרנט
                          ועשויים להתאים להעדפותיהם;
                        </li>
                        <li>
                          ניתוח פרופילים של המשתמשים בשירותי החברה, לרבות באתר, לשם שיווק מוצרים
                          לרבות אך לא רק ברשת האינטרנט;
                        </li>
                        <li>
                          לצורך משלוח באמצעים אלקטרוניים דברי פרסומת, מידע על מוצרים ושירותים,
                          הטבות, מבצעים, הנחות ומידע שיווקי;
                        </li>
                        <li>לצרכי דיוור ישיר כהגדרתו בחוק;</li>
                        <li>לצרכים פנימיים של החברה;</li>
                        <li>
                          לשם התגוננות מפני תביעות, דרישות וטענות נגד החברה ומי מטעמה וכן נגד צדדים
                          שלישיים;
                        </li>
                        <li>לשם אכיפה של הוראות תנאי השימוש ומדיניות פרטיות זו;</li>
                        <li>לשם עמידה בהוראות כל דין;</li>
                        <li>
                          כמו כן, החברה עושה שימוש במידע לא מזהה שנאסף באמצעים טכנולוגיים שונים, בין
                          היתר, לצורך תפעול של האתר, על מנת להקל את השימוש באתר, לצורך בדיקות
                          סטטיסטיות בקשר עם השימוש באתר ועוד, כמפורט בסעיף 10 למדיניות הפרטיות להלן.
                        </li>
                      </ol>
                    </li>
                    <li>
                      <strong>העברה של המידע</strong>
                      <p>
                        החברה לא תעביר ולא תמסור מידע לצדדים שלישיים, אלא כמפורט במדיניות הפרטיות.
                      </p>
                      <ol class="sub-policy-list">
                        <li>
                          העברת המידע לצדדים שלישיים תכלול מידע רלוונטי בלבד שאינו חורג מהמטרות
                          שלשמן מועבר המידע ותתבצע באופן מידתי למטרה מוגדרת, מפורשת ולגיטימית.
                        </li>
                        <li>
                          החברה רשאית להעביר את המידע או כל חלק ממנו לצדדים שלישיים בהתקיים אחד או
                          יותר מהמקרים הבאים:
                          <ol class="nested-sub-list">
                            <li>צדדים שלישיים אשר מעניקים לחברה שירותים שונים...</li>
                            <li>אם תתקבל אצל החברה הוראה לרבות צו שיפוטי...</li>
                            <li>בכל מחלוקת, טענה, דרישה, תביעה או הליכים משפטיים כלשהם...</li>
                            <li>במקרה של העברה ו/או מכירה ו/או המחאה ו/או רכישה...</li>
                            <li>אם תועלה טענה או יתעורר אצל החברה חשד...</li>
                            <li>
                              אם תועלה טענה או יתעורר אצל החברה חשד כי משתמש עושה שימוש באתר...
                            </li>
                            <li>בכל מקרה שהחברה תסבור כי מסירת המידע נדרשת...</li>
                          </ol>
                        </li>
                        <li>החברה רשאית להעביר את המידע לצדדים שלישיים...</li>
                        <li>מבלי לגרוע מהוראות מדיניות פרטיות זו...</li>
                      </ol>
                    </li>
                    <li>
                      <strong>אבטחת מידע</strong>
                      <ol class="sub-policy-list">
                        <li>החברה נוקטת באמצעים טכניים ופיזיים בעניין פרטיות ואבטחת מידע...</li>
                        <li>החברה לא מתחייבת שהאתר יהיה חסין באופן מוחלט...</li>
                      </ol>
                    </li>
                    <li>
                      <strong>הגבלת אחריות</strong>
                      <p>החברה וכל מי מטעמה לא תישא בכל חבות, והיא פטורה מכל אחריות...</p>
                    </li>
                    <li>
                      <strong>תקופת החזקה של המידע</strong>
                      <p>החברה וכל מי מטעמה לא תישא בכל חבות, והיא פטורה מכל אחריות...</p>
                    </li>
                    <li>
                      <strong>מידע על אנשים אחרים</strong>
                      <p>אם המשתמש יספק מידע לחברה בקשר לאנשים אחרים...</p>
                    </li>
                    <li>
                      <strong>Cookies</strong>
                      <p>האתר עושה שימוש ב-Cookies וטכנולוגיות אחרות...</p>
                    </li>
                    <li>
                      <strong>זכות עיון ותיקון המידע</strong>
                      <p>הזכות לעיין ולתקן את המידע היא בהתאם להוראות החוק...</p>
                    </li>
                    <li>
                      <strong>הדין החל וסמכות השיפוט</strong>
                      <ol class="sub-policy-list">
                        <li>התנאים וההוראות המפורטים במדיניות הפרטיות...</li>
                        <li>סמכות השיפוט בקשר עם כל מחלוקת ו/או תביעה...</li>
                      </ol>
                    </li>
                    <li>
                      <strong>שינויים ועדכונים</strong>
                      <p>החברה רשאית, על פי שיקול דעתה הבלעדי, לשנות את מדיניות הפרטיות...</p>
                    </li>
                    <li>
                      <strong>שונות</strong>
                      <p>המשתמש אינו רשאי להסב את זכויותיו ו/או חובותיו...</p>
                      <p>אין במדיניות פרטיות זו כדי לגרוע מכל זכות המוקנית לחברה...</p>
                    </li>
                    <li>
                      <strong>יצירת קשר</strong>
                      <p>
                        ככל שלמשתמש ישנן שאלות נוספות או הערות בנוגע למדיניות הפרטיות, המשתמש מוזמן
                        לפנות לחברה באמצעות דואר אלקטרוני בכתובת: info&#64;artisansonics.com
                      </p>
                    </li>
                  </ol>
                  <br />
                </div>
              </div>

              <!-- Submit -->
              <button
                class="login-form-submit t-btn-grad"
                (click)="acceptPolicy()"
                [disabled]="!hasReadPolicy"
              >
                <span *ngIf="!hasReadPolicy">Scroll to Continue</span>
                <span *ngIf="hasReadPolicy">I Understand & Continue</span>
              </button>

              <!-- <a class="back-to-login-link" (click)="goBackToLogin()">&#8592; Back to Login</a> -->
              <div class="policy-links-container">
                <a class="back-to-login-link" (click)="downloadPolicy()">
                  Download privacy-policy
                </a>
                <a class="back-to-login-link" (click)="goBackToLogin()"> &#8592; Back to Login </a>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="showUpdateInfoForm && !showPrivacyPolicy">
            <div class="two-factor-wrapper">
              <h2 class="login-title-3"><strong>Update Your Information</strong></h2>
              <p class="two-factor-subtitle">Please update your details below to proceed.</p>

              <div *ngIf="loginService.loginError" class="login-error main-err">
                <mat-icon class="error-icon">cancel</mat-icon>
                <span class="error-text">{{ loginService.loginError }}</span>
                <button
                  class="error-close-btn"
                  (click)="clearError()"
                  aria-label="Close error message"
                >
                  &times;
                </button>
              </div>

              <div class="form-row-split">
                <div class="login-form-row">
                  <input
                    class="login-form-field focusOnParent"
                    type="text"
                    placeholder="ID Number"
                    aria-label="ID Number"
                    [(ngModel)]="updateInfo.id"
                    (keyup.enter)="submitUpdateInfo()"
                  />
                  <i class="login-form-icon icon-id-wallet"></i>
                </div>

                <div class="login-form-row">
                  <input
                    class="login-form-field focusOnParent"
                    type="email"
                    placeholder="Email Address"
                    aria-label="Email Address"
                    [(ngModel)]="updateInfo.email"
                    (keyup.enter)="submitUpdateInfo()"
                  />
                  <i class="login-form-icon icon-email-mail"></i>
                </div>
              </div>

              <div class="form-row-split">
                <div class="phone-row-container">
                  <div class="prefix-select-wrapper">
                    <select
                      class="prefix-select"
                      [(ngModel)]="selectedPrefix"
                      (change)="onPrefixChange()"
                    >
                      <option *ngFor="let country of countryCodes" [value]="country.code">
                        {{ country.code }} ({{ country.name }})
                      </option>
                    </select>
                  </div>

                  <input
                    class="login-form-field"
                    type="tel"
                    [placeholder]="'Mobile Number'"
                    aria-label="Phone Number"
                    [(ngModel)]="phoneBody"
                    (keyup.enter)="submitUpdateInfo()"
                  />

                  <i class="login-form-icon icon-phone-mobile"></i>
                </div>
              </div>

              <div class="form-row-split">
                <div class="auth-mode-selector">
                  <div
                    style="
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                      width: 100%;
                      margin-bottom: 12px;
                    "
                  >
                    <label class="auth-mode-label" style="margin-bottom: 0"
                      >Select Authentication Method:</label
                    >
                  </div>

                  <div class="auth-button-group">
                    <button
                      type="button"
                      class="auth-button"
                      [class.active]="updateInfo.authMode === 'whatsapp'"
                      (click)="updateInfo.authMode = 'whatsapp'"
                    >
                      WhatsApp
                    </button>
                    <button
                      type="button"
                      class="auth-button"
                      [class.active]="updateInfo.authMode === 'SMS'"
                      [class.disabled-btn]="selectedPrefix !== '+972'"
                      [disabled]="selectedPrefix !== '+972'"
                      (click)="selectedPrefix === '+972' && (updateInfo.authMode = 'SMS')"
                    >
                      SMS
                    </button>
                  </div>

                  <div class="intl-info-msg" *ngIf="selectedPrefix !== '+972'">
                    <mat-icon class="info-icon-small">info</mat-icon>
                    <span>International numbers support <strong>WhatsApp only</strong>.</span>
                  </div>
                </div>
              </div>

              <button
                class="login-form-submit t-btn-grad"
                (click)="submitUpdateInfo()"
                [disabled]="isUpdateLoading"
              >
                <span [class.hidden]="isUpdateLoading">Update & Continue</span>
                <mat-spinner
                  *ngIf="isUpdateLoading"
                  class="button-spinner"
                  [diameter]="24"
                ></mat-spinner>
              </button>

              <a class="back-to-login-link" (click)="goBackToLogin()">&#8592; Back to Login</a>
            </div>
          </ng-container>

          <ng-container
            *ngIf="
              loginService.clinicOptions &&
              !showUpdateInfoForm &&
              !showPrivacyPolicy &&
              !showUserSelection
            "
          >
            <div class="search-clinic">
              <div class="login-form-row">
                <input
                  class="login-form-field"
                  type="text"
                  placeholder="Search Clinic"
                  aria-label="search clinic"
                  [(ngModel)]="clinicSearchValue"
                  (keyup)="clinicSearch()"
                />
                <i class="login-form-icon icon-search"></i>
              </div>
            </div>
            <!-- Select Clinic -->
            <section class="clinic-selection clinic-scroll">
              <div *ngFor="let c of loginService.filteredClinicSearch; let i = index">
                <div class="login-form-row" (click)="setClinic(c)">
                  <span class="clinic-text">{{ c.ClinicTitle }}</span>
                  <i class="login-form-icon icon-userName"></i>
                </div>
              </div>
            </section>

            <a class="back-to-login-link" (click)="goBackToLogin()">&#8592; Back to Login</a>
          </ng-container>
          <ng-container *ngIf="showUserSelection && !showUpdateInfoForm && !showPrivacyPolicy">
            <div class="two-factor-wrapper">
              <h2 class="login-title-3"><strong>Select User</strong></h2>
              <p class="two-factor-subtitle">Select the user you wish to log in as.</p>
            </div>

            <div class="search-clinic">
              <div class="login-form-row">
                <input
                  class="login-form-field"
                  type="text"
                  placeholder="Search User"
                  [(ngModel)]="userSearchValue"
                  (keyup)="userSearch()"
                />
                <i class="login-form-icon icon-search"></i>
              </div>
            </div>

            <section class="clinic-selection user-scroll">
              <div *ngFor="let user of loginService.filteredUserSearch">
                <div class="login-form-row clickable-row" (click)="selectUser(user)">
                  <div style="display: flex; flex-direction: column; width: 85%">
                    <span style="font-weight: 500; font-size: 1.1em">{{
                      user.Name || user.UserName
                    }}</span>
                    <span style="font-size: 0.85em; opacity: 0.8" *ngIf="user.Title">{{
                      user.Title
                    }}</span>
                  </div>
                  <i class="login-form-icon icon-id-wallet"></i>
                </div>
              </div>

              <div
                *ngIf="loginService.filteredUserSearch.length === 0"
                style="text-align: center; color: #fff; padding: 20px"
              >
                No users found.
              </div>
            </section>

            <a class="back-to-login-link" (click)="showUserSelection = false; userSearchValue = ''"
              >&#8592; Back to Clinics</a
            >
          </ng-container>
        </div>
      </div>
    </div>

    <div class="l-row">
      <footer class="l-flex-c l-flex-w login-footer">
        <div class="l-fg1 login-footer-text">
          Got Problems with login?
          <a>Contact Us</a>
        </div>

        <div class="l-fg2 login-footer-text">
          <a href="/privacy-policy">Privacy Policy</a>
        </div>

        <div class="login-footer-credit">
          © All rights reserved Artisan Sonics {{ currentYear }}
        </div>
      </footer>
    </div>
  </div>

  <img
    id="login_display"
    src="../../assets/images/login-display.png"
    alt=""
    *ngIf="!loginService.altSplashPage"
  />
</span>
<!-- <img *ngIf="loginService.altSplashPage" [src]="loginService.altSplashPage" style="position:absolute; top:0; right:0; width: 100%"> -->
<div id="cookie-popup" class="cookie-popup glass-card" *ngIf="showCookiePopup">
  <p>
    We use cookies to enhance your browsing experience and analyze our traffic. By clicking "Allow,"
    you consent to our use of cookies. <a routerLink="/privacy-policy">Learn more</a>.
  </p>
  <div class="cookie-actions">
    <button
      id="cookie-deny"
      class="cookie-button cookie-deny orange-btn"
      (click)="handleConsent('essential')"
    >
      Allow only essential
    </button>
    <button
      id="cookie-allow"
      class="cookie-button cookie-allow blue-btn"
      (click)="handleConsent('allowed')"
    >
      Allow
    </button>
  </div>
</div>
